import { Tabs, TabsProps } from 'antd';

import styles from './index.module.scss';

export const CommonTabs = (props: TabsProps) => {
  return (
    <Tabs {...props} className={`${styles.tabs} ${props.className || ''}`} />
  );
};
